module.exports = __webpack_public_path__ + "img/sidebar-onoff.169bf3db.png";